"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSucceeded = exports.requestFailed = exports.requestLoading = exports.RequestActionType = void 0;
const base_1 = require("./base");
var RequestActionType;
(function (RequestActionType) {
    RequestActionType["REQUEST_LOADING"] = "REQUEST_LOADING";
    RequestActionType["REQUEST_FAILED"] = "REQUEST_FAILED";
    RequestActionType["REQUEST_SUCCEEDED"] = "REQUEST_SUCCEEDED";
    RequestActionType["REQUEST_STATE_CHANGED"] = "REQUEST_STATE_CHANGED";
})(RequestActionType = exports.RequestActionType || (exports.RequestActionType = {}));
exports.requestLoading = (0, base_1.actionCreator)(RequestActionType.REQUEST_LOADING);
exports.requestFailed = (0, base_1.actionCreator)(RequestActionType.REQUEST_FAILED);
exports.requestSucceeded = (0, base_1.actionCreator)(RequestActionType.REQUEST_SUCCEEDED);
//# sourceMappingURL=result.js.map